import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Home from "@/pages/Home";
import Immobili from "@/pages/Immobili";
import PropertyDetail from "@/pages/PropertyDetail";
import StudioTecnico from "@/pages/StudioTecnico";
import AgenziaImmobiliare from "@/pages/AgenziaImmobiliare";
import Amministrazioni from "@/pages/Amministrazioni";
import ChiSiamo from "@/pages/ChiSiamo";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import ValutaCasa from "@/pages/ValutaCasa";
import PreventivoCondominio from "@/pages/PreventivoCondominio";
import CambioAmministratore from "@/pages/CambioAmministratore";
import Tariffario from "@/pages/Tariffario";
import { AmministratoreScandicci, AmministratoreFirenze } from "@/pages/AmministratoreLocale";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/Login";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import LegacyBlogRedirect from "@/components/LegacyBlogRedirect";
import PageTracker from "@/components/PageTracker";
import GoogleAnalytics from "@/components/GoogleAnalytics";

import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminProperties from "@/pages/admin/AdminProperties";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";

function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#1B2A41] font-mono">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PageTracker />
          <GoogleAnalytics />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/immobili" element={<Immobili />} />
            <Route path="/immobili/:slug" element={<PropertyDetail />} />
            <Route path="/studio-tecnico/" element={<StudioTecnico />} />
            <Route path="/studio-tecnico" element={<Navigate to="/studio-tecnico/" replace />} />
            <Route path="/agenzia-immobiliare-scandicci/" element={<AgenziaImmobiliare />} />
            <Route path="/agenzia-immobiliare-scandicci" element={<Navigate to="/agenzia-immobiliare-scandicci/" replace />} />
            <Route path="/amministrazioni-condominiali/" element={<Amministrazioni />} />
            <Route path="/amministrazioni-condominiali" element={<Navigate to="/amministrazioni-condominiali/" replace />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact/" element={<Contact />} />
            <Route path="/contact" element={<Navigate to="/contact/" replace />} />
            <Route path="/contatti" element={<Navigate to="/contact/" replace />} />
            <Route path="/valuta-la-tua-casa" element={<ValutaCasa />} />
            <Route path="/preventivo-condominio" element={<PreventivoCondominio />} />
            <Route path="/cambio-amministratore-condominio" element={<CambioAmministratore />} />
            <Route path="/tariffario-condominio" element={<Tariffario />} />
            <Route path="/amministratore-condominio-scandicci" element={<AmministratoreScandicci />} />
            <Route path="/amministratore-condominio-firenze" element={<AmministratoreFirenze />} />
            <Route path="/login" element={<Login />} />

            {/* Redirect 301 (client-side) da URL WordPress legacy per preservare la SEO */}
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/blog-immobiliare" element={<Navigate to="/blog" replace />} />
            <Route path="/blog-immobiliare/" element={<Navigate to="/blog" replace />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
            <Route path="/:year/:month/:day/:slug" element={<LegacyBlogRedirect />} />
            <Route path="/:year/:month/:day/:slug/" element={<LegacyBlogRedirect />} />

            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="immobili" element={<AdminProperties />} />
              <Route path="lead" element={<AdminLeads />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="statistiche" element={<AdminAnalytics />} />
              <Route path="impostazioni" element={<AdminSettings />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
